import {
	PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_SORT,
	PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/phoneCallList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';
import { PhoneCallListItem } from 'src/models/phoneCallList';
import { SerializedQuery } from 'src/models/query';

interface PhoneCallListStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	directionFilter: 'combined' | 'in' | 'out';
	filterBoxes: Array<FilterBoxes>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	listViewModeLarge: boolean;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	phoneCallListAll: Array<PhoneCallListItem>;
	phoneCallListAllSliced: Map<number, Array<PhoneCallListItem>>;
	phoneCallListAllTotalCount: number;
	phoneCallListMine: Array<PhoneCallListItem>;
	phoneCallListMineSliced: Map<number, Array<PhoneCallListItem>>;
	phoneCallListMineTotalCount: number;
	phoneCallListOpen: Array<PhoneCallListItem>;
	phoneCallListOpenSliced: Map<number, Array<PhoneCallListItem>>;
	phoneCallListOpenTotalCount: number;
	queryStoreSubscriptions: Array<SerializedQuery>;
	selectedSharedQueryId: string;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
	today: string;
}

function state(): PhoneCallListStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>([
			[ActivityListTypeEnum.ALL, ''],
			[ActivityListTypeEnum.MINE, ''],
			[ActivityListTypeEnum.OPEN, ''],
		]),
		dateFilter: new Date().toISOString().split('T')[0],
		dateTimeRangeFilter: PreconfiguredTimeRanges.TODAY,
		directionFilter: 'combined',
		filterBoxes: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredUsers: [],
		listViewModeLarge:
			localStorage.getItem(PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.ALL, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.MINE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.OPEN, { page: 1, rowsPerPage: 100 }],
		]),
		phoneCallListAll: [],
		phoneCallListAllSliced: new Map<number, Array<PhoneCallListItem>>(),
		phoneCallListAllTotalCount: 0,
		phoneCallListMine: [],
		phoneCallListMineSliced: new Map<number, Array<PhoneCallListItem>>(),
		phoneCallListMineTotalCount: 0,
		phoneCallListOpen: [],
		phoneCallListOpenSliced: new Map<number, Array<PhoneCallListItem>>(),
		phoneCallListOpenTotalCount: 0,
		queryStoreSubscriptions: [],
		selectedSharedQueryId: '',
		sort:
			localStorage.getItem(PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'DESC',
								property: 'timestamp',
							},
						],
					]),
		today: new Date().toISOString().split('T')[0],
	};
}

export default state;
